import { NgModule } from '@angular/core'
import { SharedModule } from '../../../common/modules/shared';

// Import components
import { ChildrenListComponent } from './ChildrenListComponent'
import { ChildrenListRouter } from './ChildrenListRouting'

@NgModule({
    declarations: [
        ChildrenListComponent
    ],
    imports: [
        SharedModule,
        ChildrenListRouter
    ]
})

export class ChildrenListModule {

}


// WEBPACK FOOTER //
// ./src/bus/parent/children-list/ChildrenListModule.ts